(function (angular) {
    'use strict';

    angular.module('chat2')
        /**
         * Directive to scroll to bottom when content changes.
         * Apply to a list that has a fixed height and overflow auto style.
         */
        .directive('availability', ["$stateParams", "jwtService", "chatPresenceService", function ($stateParams, jwtService, chatPresenceService) {

            var controllerFn = ['$scope',
                function ($scope) {

                    $scope.presence = {
                    };
                    $scope.presence.available = (chatPresenceService.getMyPresence() === "available");

                    $scope.doAvailable = function () {

                        if (!$scope.presence.available) {
                            chatPresenceService.changePresenceToAway($stateParams.pickedApiSpaceId)
                                .then(function () {

                                }).catch(function () {
                                    $scope.presence.available = true;
                                });
                        }
                        else {
                            chatPresenceService.changePresenceToBack($stateParams.pickedApiSpaceId)
                                .then(function () {

                                }).catch(function () {
                                    $scope.presence.available = false;
                                });
                        }
                    };

                }
            ];

            return {
                restrict: 'EA',
                scope: {
                },
                templateUrl: 'components/toolkit/chat/templates/directive.availability.html',
                controller: controllerFn
            };

        }]);
})(window.angular);
